import React from 'react';

import { CellRendererProps } from '../../DataTable.types';

import styles from './GradientTextCellRenderer.module.scss';

export interface GradientTextData {
    text: string;
    subText?: string;
}

export const GradientTextCellRenderer: React.FC<CellRendererProps> = ({ value }) => {
    // Support both string and object formats
    const data: GradientTextData = typeof value === 'string' ? { text: value } : value || { text: '' };

    const { text: mainText, subText: secondaryText } = data;

    // Check text content to determine styling
    const isNotApplicable = mainText && mainText.toLowerCase().includes('not applicable');
    const shouldUseNormalColor =
        mainText && (mainText.toLowerCase().includes('turned off') || mainText.toLowerCase().includes('attempts over'));

    // Determine which CSS class to use
    const getTextClassName = () => {
        if (isNotApplicable) return styles.mainTextNotApplicable;
        if (shouldUseNormalColor) return styles.mainTextNormal;
        return styles.mainText;
    };

    return (
        <div className={styles.gradientTextContainer}>
            <div className={getTextClassName()}>{mainText}</div>
            {secondaryText && <div className={styles.secondaryText}>{secondaryText}</div>}
        </div>
    );
};
